import { Select, Form, Input } from "antd";
import type { Rule } from "antd/es/form";

const SELECT_STYLE = { fontSize: "14px", padding: "14px 16px" };
const REQUIRED_COLOR = "#C00";

function renderLabel(text: string, required = false) {
  return (
    <span style={{ fontWeight: 600 }}>
      {text}
      {required ? <span style={{ color: REQUIRED_COLOR }}>*</span> : null}
    </span>
  );
}

function requiredRule(messageText: string) {
  return [{ required: true, message: messageText }];
}

function renderSelect(
  placeholder: string,
  options: { label: string; value: string | number }[],
) {
  return (
    <Select
      size="large"
      style={SELECT_STYLE}
      placeholder={placeholder}
      showSearch
      options={options}
    />
  );
}

function renderRequiredInputItem(
  name: string,
  label: string,
  messageText: string,
  placeholder: string,
  maxLength?: number,
  type: "text" | "number" = "text",
  className?: string,
) {
  return (
    <Form.Item
      className={className}
      label={renderLabel(label, true)}
      name={name}
      rules={requiredRule(messageText)}
    >
      <Input type={type} placeholder={placeholder} size="large" maxLength={maxLength} />
    </Form.Item>
  );
}

function renderRequiredSelectItem(
  name: string,
  label: string,
  messageText: string,
  placeholder: string,
  options: { label: string; value: string | number }[],
  className?: string,
  extraRules: Rule[] = [],
  dependencies?: string[],
) {
  return (
    <Form.Item
      className={className}
      label={renderLabel(label, true)}
      name={name}
      rules={[...requiredRule(messageText), ...extraRules]}
      dependencies={dependencies}
    >
      {renderSelect(placeholder, options)}
    </Form.Item>
  );
}

export {
  renderRequiredInputItem,
  renderRequiredSelectItem,
  renderLabel,
  requiredRule,
  renderSelect,
};
